module.exports = __webpack_public_path__ + "static/img/product_bg2.92f6811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_bg2.png
// module id = 8ozt
// module chunks = 1